export default __webpack_public_path__ + "static/media/header-food.2d1dfea6.jpg";